// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Portafogli.css */

*,
*::before,
*::after { box-sizing: border-box; }

.portafogli-page {
  max-width: 750px;
}

.portafogli-page h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gray-900, #111827);
  margin: 0 0 1.5rem;
}

/* Form aggiunta */
.portafogli-form {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.portafogli-input {
  padding: 0.75rem 0.75rem;
  border: 2px solid var(--gray-200, #e5e7eb);
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.95rem;
  background: #ffffff;
  color: #111827;
  outline: none;
  transition: border-color 150ms;
  font-family: inherit;
}

.portafogli-input-nome {
  flex: 2 1;
  min-width: 130px;
}

.portafogli-input-importo {
  flex: 1 1;
  min-width: 90px;
}

.portafogli-input-tipo {
  flex: 1.2 1;
  min-width: 100px;
  cursor: pointer;
  appearance: auto;
  -webkit-appearance: auto;
}

.portafogli-input:focus {
  border-color: var(--primary-color, #4f46e5);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.portafogli-add-btn {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: var(--radius-md, 0.5rem);
  background: var(--primary-color, #4f46e5);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 150ms;
}

.portafogli-add-btn:hover {
  background: var(--primary-hover, #4338ca);
}

.portafogli-add-btn svg {
  width: 22px;
  height: 22px;
}

/* Messaggi */
.portafogli-message {
  padding: 0.75rem 1rem;
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.portafogli-message.error {
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
}

.portafogli-message.success {
  background: #f0fdf4;
  color: #10b981;
  border: 1px solid #bbf7d0;
}

/* Stato vuoto */
.portafogli-empty {
  text-align: center;
  padding: 3rem 1rem;
  background: #fff;
  border: 2px dashed var(--gray-300, #d1d5db);
  border-radius: var(--radius-lg, 0.75rem);
}

.empty-icon { font-size: 2.5rem; }
.portafogli-empty p { color: var(--gray-500, #6b7280); margin: 0.5rem 0; }
.empty-hint { font-size: 0.85rem; color: var(--gray-400, #9ca3af); }

/* Lista */
.portafogli-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.portafogli-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1rem;
  background: #fff;
  border: 1px solid var(--gray-200, #e5e7eb);
  border-radius: var(--radius-md, 0.5rem);
  transition: box-shadow 150ms;
}

.portafogli-item:hover {
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05));
}

.portafogli-item-generale {
  background: #fefce8;
  border-color: #fde047;
}

.pf-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
  width: 28px;
  text-align: center;
}

.pf-name {
  flex: 1 1;
  font-size: 1rem;
  color: #1f2937;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pf-tipo-label {
  font-size: 0.8rem;
  color: #9ca3af;
  background: #f3f4f6;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
}

.pf-ruolo-badge {
  font-size: 0.72rem;
  color: #7c3aed;
  background: #ede9fe;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
}

.pf-valore {
  font-size: 1rem;
  color: #1f2937;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Pulsanti azione */
.pf-invite-btn,
.pf-edit-btn,
.pf-delete-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 150ms;
}

.pf-invite-btn {
  color: var(--gray-400, #9ca3af);
}
.pf-invite-btn:hover {
  background: #ede9fe;
  color: #7c3aed;
}

.pf-edit-btn {
  color: var(--gray-400, #9ca3af);
}
.pf-edit-btn:hover {
  background: #eff6ff;
  color: #3b82f6;
}

.pf-delete-btn {
  color: var(--gray-400, #9ca3af);
}
.pf-delete-btn:hover {
  background: #fef2f2;
  color: #ef4444;
}

.pf-edit-btn svg,
.pf-delete-btn svg { width: 16px; height: 16px; }

/* Modifica inline */
.portafogli-edit-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  flex-wrap: wrap;
}

.portafogli-edit-input {
  padding: 0.5rem 0.6rem;
  border: 2px solid var(--primary-color, #4f46e5);
  border-radius: var(--radius-sm, 0.375rem);
  font-size: 0.9rem;
  background: #fff;
  color: #111827;
  outline: none;
  font-family: inherit;
  flex: 2 1;
  min-width: 100px;
}

.portafogli-edit-importo {
  flex: 1 1;
  min-width: 80px;
}

.portafogli-edit-tipo {
  flex: 1.2 1;
  min-width: 90px;
  cursor: pointer;
  appearance: auto;
  -webkit-appearance: auto;
}

.portafogli-edit-actions {
  display: flex;
  gap: 0.35rem;
  flex-shrink: 0;
}

.portafogli-edit-save,
.portafogli-edit-cancel {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms;
}

.portafogli-edit-save {
  background: #dcfce7;
  color: #16a34a;
}
.portafogli-edit-save:hover {
  background: #bbf7d0;
}

.portafogli-edit-cancel {
  background: #fee2e2;
  color: #ef4444;
}
.portafogli-edit-cancel:hover {
  background: #fecaca;
}

.portafogli-edit-save svg,
.portafogli-edit-cancel svg {
  width: 16px;
  height: 16px;
}

.portafogli-loading {
  color: var(--gray-500, #6b7280);
  font-size: 1rem;
}

/* Tablet */
@media (max-width: 1023px) {
  .portafogli-page { max-width: 100%; }
  .portafogli-form { gap: 0.4rem; }
  .portafogli-input { padding: 0.65rem 0.6rem; font-size: 0.9rem; }
  .pf-tipo-label { display: none; }
}

/* Mobile */
@media (max-width: 767px) {
  .portafogli-page { max-width: 100%; }
  .portafogli-page h2 { font-size: 1.25rem; margin-bottom: 1rem; }

  .portafogli-form {
    flex-direction: column;
  }

  .portafogli-input-nome,
  .portafogli-input-importo,
  .portafogli-input-tipo {
    flex: none;
    width: 100%;
    min-width: 0;
  }

  .portafogli-add-btn {
    width: 100%;
    height: 44px;
  }

  .portafogli-item {
    padding: 0.75rem 0.85rem;
    gap: 0.4rem;
  }

  .pf-name { font-size: 0.9rem; }
  .pf-valore { font-size: 0.9rem; }
  .pf-tipo-label { display: none; }

  .portafogli-edit-row {
    flex-direction: column;
  }

  .portafogli-edit-input {
    width: 100%;
    flex: none;
    min-width: 0;
  }

  .portafogli-edit-actions {
    width: 100%;
    justify-content: flex-end;
    margin-top: 0.25rem;
  }

  .pf-edit-btn,
  .pf-delete-btn {
    width: 36px;
    height: 36px;
  }
  .pf-edit-btn svg,
  .pf-delete-btn svg { width: 18px; height: 18px; }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Portafogli.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;;WAEW,sBAAsB,EAAE;;AAEnC;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA,cAAc,iBAAiB,EAAE;AACjC,sBAAsB,+BAA+B,EAAE,gBAAgB,EAAE;AACzE,cAAc,kBAAkB,EAAE,+BAA+B,EAAE;;AAEnE,UAAU;AACV;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;EAC1C,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;;;EAGE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;qBACqB,WAAW,EAAE,YAAY,EAAE;;AAEhD,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB,eAAe,EAAE;EACpC,mBAAmB,WAAW,EAAE;EAChC,oBAAoB,uBAAuB,EAAE,iBAAiB,EAAE;EAChE,iBAAiB,aAAa,EAAE;AAClC;;AAEA,WAAW;AACX;EACE,mBAAmB,eAAe,EAAE;EACpC,sBAAsB,kBAAkB,EAAE,mBAAmB,EAAE;;EAE/D;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,WAAW;EACb;;EAEA,WAAW,iBAAiB,EAAE;EAC9B,aAAa,iBAAiB,EAAE;EAChC,iBAAiB,aAAa,EAAE;;EAEhC;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;uBACqB,WAAW,EAAE,YAAY,EAAE;AAClD","sourcesContent":["/* Portafogli.css */\n\n*,\n*::before,\n*::after { box-sizing: border-box; }\n\n.portafogli-page {\n  max-width: 750px;\n}\n\n.portafogli-page h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--gray-900, #111827);\n  margin: 0 0 1.5rem;\n}\n\n/* Form aggiunta */\n.portafogli-form {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n  flex-wrap: wrap;\n}\n\n.portafogli-input {\n  padding: 0.75rem 0.75rem;\n  border: 2px solid var(--gray-200, #e5e7eb);\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 0.95rem;\n  background: #ffffff;\n  color: #111827;\n  outline: none;\n  transition: border-color 150ms;\n  font-family: inherit;\n}\n\n.portafogli-input-nome {\n  flex: 2;\n  min-width: 130px;\n}\n\n.portafogli-input-importo {\n  flex: 1;\n  min-width: 90px;\n}\n\n.portafogli-input-tipo {\n  flex: 1.2;\n  min-width: 100px;\n  cursor: pointer;\n  appearance: auto;\n  -webkit-appearance: auto;\n}\n\n.portafogli-input:focus {\n  border-color: var(--primary-color, #4f46e5);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.portafogli-add-btn {\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: var(--radius-md, 0.5rem);\n  background: var(--primary-color, #4f46e5);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 150ms;\n}\n\n.portafogli-add-btn:hover {\n  background: var(--primary-hover, #4338ca);\n}\n\n.portafogli-add-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n/* Messaggi */\n.portafogli-message {\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.portafogli-message.error {\n  background: #fef2f2;\n  color: #ef4444;\n  border: 1px solid #fecaca;\n}\n\n.portafogli-message.success {\n  background: #f0fdf4;\n  color: #10b981;\n  border: 1px solid #bbf7d0;\n}\n\n/* Stato vuoto */\n.portafogli-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  background: #fff;\n  border: 2px dashed var(--gray-300, #d1d5db);\n  border-radius: var(--radius-lg, 0.75rem);\n}\n\n.empty-icon { font-size: 2.5rem; }\n.portafogli-empty p { color: var(--gray-500, #6b7280); margin: 0.5rem 0; }\n.empty-hint { font-size: 0.85rem; color: var(--gray-400, #9ca3af); }\n\n/* Lista */\n.portafogli-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.portafogli-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1rem;\n  background: #fff;\n  border: 1px solid var(--gray-200, #e5e7eb);\n  border-radius: var(--radius-md, 0.5rem);\n  transition: box-shadow 150ms;\n}\n\n.portafogli-item:hover {\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05));\n}\n\n.portafogli-item-generale {\n  background: #fefce8;\n  border-color: #fde047;\n}\n\n.pf-icon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n  width: 28px;\n  text-align: center;\n}\n\n.pf-name {\n  flex: 1;\n  font-size: 1rem;\n  color: #1f2937;\n  font-weight: 500;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pf-tipo-label {\n  font-size: 0.8rem;\n  color: #9ca3af;\n  background: #f3f4f6;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.pf-ruolo-badge {\n  font-size: 0.72rem;\n  color: #7c3aed;\n  background: #ede9fe;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.pf-valore {\n  font-size: 1rem;\n  color: #1f2937;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Pulsanti azione */\n.pf-invite-btn,\n.pf-edit-btn,\n.pf-delete-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 150ms;\n}\n\n.pf-invite-btn {\n  color: var(--gray-400, #9ca3af);\n}\n.pf-invite-btn:hover {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.pf-edit-btn {\n  color: var(--gray-400, #9ca3af);\n}\n.pf-edit-btn:hover {\n  background: #eff6ff;\n  color: #3b82f6;\n}\n\n.pf-delete-btn {\n  color: var(--gray-400, #9ca3af);\n}\n.pf-delete-btn:hover {\n  background: #fef2f2;\n  color: #ef4444;\n}\n\n.pf-edit-btn svg,\n.pf-delete-btn svg { width: 16px; height: 16px; }\n\n/* Modifica inline */\n.portafogli-edit-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.portafogli-edit-input {\n  padding: 0.5rem 0.6rem;\n  border: 2px solid var(--primary-color, #4f46e5);\n  border-radius: var(--radius-sm, 0.375rem);\n  font-size: 0.9rem;\n  background: #fff;\n  color: #111827;\n  outline: none;\n  font-family: inherit;\n  flex: 2;\n  min-width: 100px;\n}\n\n.portafogli-edit-importo {\n  flex: 1;\n  min-width: 80px;\n}\n\n.portafogli-edit-tipo {\n  flex: 1.2;\n  min-width: 90px;\n  cursor: pointer;\n  appearance: auto;\n  -webkit-appearance: auto;\n}\n\n.portafogli-edit-actions {\n  display: flex;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n.portafogli-edit-save,\n.portafogli-edit-cancel {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 150ms;\n}\n\n.portafogli-edit-save {\n  background: #dcfce7;\n  color: #16a34a;\n}\n.portafogli-edit-save:hover {\n  background: #bbf7d0;\n}\n\n.portafogli-edit-cancel {\n  background: #fee2e2;\n  color: #ef4444;\n}\n.portafogli-edit-cancel:hover {\n  background: #fecaca;\n}\n\n.portafogli-edit-save svg,\n.portafogli-edit-cancel svg {\n  width: 16px;\n  height: 16px;\n}\n\n.portafogli-loading {\n  color: var(--gray-500, #6b7280);\n  font-size: 1rem;\n}\n\n/* Tablet */\n@media (max-width: 1023px) {\n  .portafogli-page { max-width: 100%; }\n  .portafogli-form { gap: 0.4rem; }\n  .portafogli-input { padding: 0.65rem 0.6rem; font-size: 0.9rem; }\n  .pf-tipo-label { display: none; }\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .portafogli-page { max-width: 100%; }\n  .portafogli-page h2 { font-size: 1.25rem; margin-bottom: 1rem; }\n\n  .portafogli-form {\n    flex-direction: column;\n  }\n\n  .portafogli-input-nome,\n  .portafogli-input-importo,\n  .portafogli-input-tipo {\n    flex: none;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .portafogli-add-btn {\n    width: 100%;\n    height: 44px;\n  }\n\n  .portafogli-item {\n    padding: 0.75rem 0.85rem;\n    gap: 0.4rem;\n  }\n\n  .pf-name { font-size: 0.9rem; }\n  .pf-valore { font-size: 0.9rem; }\n  .pf-tipo-label { display: none; }\n\n  .portafogli-edit-row {\n    flex-direction: column;\n  }\n\n  .portafogli-edit-input {\n    width: 100%;\n    flex: none;\n    min-width: 0;\n  }\n\n  .portafogli-edit-actions {\n    width: 100%;\n    justify-content: flex-end;\n    margin-top: 0.25rem;\n  }\n\n  .pf-edit-btn,\n  .pf-delete-btn {\n    width: 36px;\n    height: 36px;\n  }\n  .pf-edit-btn svg,\n  .pf-delete-btn svg { width: 18px; height: 18px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
